import contentRequest from '~/src/api/requests/contentRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

interface IRetailPoint {
    point_id: 3963,
    address: 'пр-т Дзержинского, 23',
    work_time: 'Пн-вс с 10:00 до 22:00 (платежи принимаются до 21:30), без выходных.',
    point_name: 'Сервисный центр (ТРЦ «Север»)',
    phone: '',
    longitude: 55.1288,
    latitude: 51.8334,
    company: Record<string, unknown>
}

export type TRetailPointResponse = TResponse<Record<string, IRetailPoint[]>, any>;

interface IProps {
    domain: string,
}

/**
 * GET-запрос точки продаж
 * https://api-content.domru.ru/perm/v2/retail-point
 * @param {string=} [domain='perm'] поддомен хоста b2c
 */
export const getRetailPoint = async({ domain = '' }: IProps): Promise<TRetailPointResponse> => {
    const url = `${domain}/v2/retail-point`;
    try {
        const response = await contentRequest.getWithCache(url);

        return {
            isSuccess: true,
            payload: response.data
        };
    } catch (err) {
        return captureQueryError(err);
    }
};
